import { PageComponentProps } from 'piral-core'
import * as React from 'react'
import MainMessage from '../components/MainMessage'

export default function SignOutCallback(props: PageComponentProps) {
    return (
        <>
            <t-page-title>Signed out</t-page-title>
            <MainMessage title="Signed out" summary='You have been signed out'>
                <sp-button href="/">
                    Sign back in
                </sp-button>
            </MainMessage>
        </>
    )
}
